
import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import Dashboard from "./components/Dashboard";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Report from "./components/Report";
import ReportViewer from "./components/Report_Pages/ReportViewer";
import ImmobilizeMobilize from "./components/ImmobilizeMobilize";
import Alerts from "./components/Alerts";
import Login from "./components/Login";
import UserManagement from "./components/UserManagement";
import TripsDashboard from "./components/TripsDashboard";
import ClientUserManagement from "./components/ClientUserManagement";
import Account from "./components/Account";
import VehiclesTable from "./components/VehiclesTable";
import POIDashboard from "./components/(POI)Dashboard";
import PermissionDashboard from "./components/PermissionDashboard";
import Connectivity from "./components/Connectivity";
import BatteryDashboard from "./components/BatteryDashboard";
import ECUDeploymentStatus from "./components/ECUDeploymentStatus";
import OverAirUpdatesLogs from "./components/Over-AirUpdatesLogs";
import VehicleDetails from "./components/VehicleDetails";
import Provisioning from "./components/Provisioning";
import ParameterOverAir from "./components/ParameterOverAir";
import DeviceCondition from "./components/DeviceCondition";
import FirmwareOverAir from "./components/FirmwareOverAir";
import Deviceassociate from "./components/DeviceAssociate";
import RollOut from "./components/RollOut";
import Approvals from "./components/Approvals";
import DeviceFotaDeploymentStatus from "./components/DeviceFotaDeploymentStatus";
import MapTracker from "./components/SharingMap";
import ECUOverAirUpdatesLogs from "./components/ECUOverAirUpdatesLogs";
import ECUFotaDeploymentStatus from "./components/ECUFotaDeploymentStatus";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {},
  },
});

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App-container">
          <Routes>
            <Route path="/" element={<Login />} />

            <Route
              path="/Dashboard"
              element={
                <ProtectedRoute>
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Dashboard />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/vehicle/:vehicleId"
              element={
                <ProtectedRoute>
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <VehicleDetails />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/Alerts"
              element={
                <PageProtectedRoute pageCode="ALERTS">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Alerts />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/Report"
              element={
                <PageProtectedRoute pageCode="REPORTS">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Report />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/report/:reportId"
              element={
                <PageProtectedRoute pageCode="REPORTS">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ReportViewer />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/ImmobilizeMobilize"
              element={
                <PageProtectedRoute pageCode="GPIO">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ImmobilizeMobilize />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/TripsDashboard"
              element={
                <PageProtectedRoute pageCode="TRIPS">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <TripsDashboard />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/UserManagement"
              element={
                <PageProtectedRoute pageCode="USER_MANAGEMENT">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <UserManagement />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/ClientUserManagement"
              element={
                <ProtectedRoute>
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ClientUserManagement />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/Account"
              element={
                <ProtectedRoute>
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Account />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/VehiclesTable"
              element={
                <PageProtectedRoute pageCode="VEHICLES">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <VehiclesTable />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/POIDashboard"
              element={
                <PageProtectedRoute pageCode="AOI">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <POIDashboard />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/PermissionDashboard"
              element={
                <RoleProtectedRoute allowedRoles={["SuperAdmin"]}>
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <PermissionDashboard />
                  </MainLayout>
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/Connectivity"
              element={
                <PageProtectedRoute pageCode="CONNECTIVITY">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Connectivity />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/BatteryDashboard"
              element={
                <RoleProtectedRoute allowedRoles={["SuperAdmin"]}>
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <BatteryDashboard />
                  </MainLayout>
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/ECUDeploymentStatus"
              element={
                <PageProtectedRoute pageCode="ECU_FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ECUDeploymentStatus />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/OverAirUpdatesLogs"
              element={
                <PageProtectedRoute pageCode="FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <OverAirUpdatesLogs />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/Provisioning"
              element={
                <PageProtectedRoute pageCode="PROVISIONING">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Provisioning />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/ParameterOverAir"
              element={
                <PageProtectedRoute pageCode="PARAMETER_OTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ParameterOverAir />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/DeviceCondition"
              element={
                <PageProtectedRoute pageCode="DEVICES">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <DeviceCondition />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/FirmwareOverAir"
              element={
                <PageProtectedRoute pageCode="FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <FirmwareOverAir />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/Deviceassociate"
              element={
                <PageProtectedRoute pageCode="DEVICES">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Deviceassociate />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/RollOut"
              element={
                <PageProtectedRoute pageCode="ECU_FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <RollOut />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/Approvals"
              element={
                <PageProtectedRoute pageCode="ECU_FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <Approvals />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/DeviceFotaDeploymentStatus/:id"
              element={
                <PageProtectedRoute pageCode="FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <DeviceFotaDeploymentStatus />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/ECUFotaDeploymentStatus/:id"
              element={
                <PageProtectedRoute pageCode="ECU_FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ECUFotaDeploymentStatus />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route
              path="/ECUOverAirUpdatesLogs"
              element={
                <PageProtectedRoute pageCode="ECU_FOTA">
                  <MainLayout
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                  >
                    <ECUOverAirUpdatesLogs />
                  </MainLayout>
                </PageProtectedRoute>
              }
            />

            <Route path="/SharingMap/:token" element={<MapTracker />} />

            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Navigate to="/Dashboard" />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  return token ? children : <Navigate to="/" />;
};

const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");

  if (!token) {
    return <Navigate to="/" />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/Dashboard" />;
  }

  return children;
};

const PageProtectedRoute = ({ children, pageCode }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const storedPermission = localStorage.getItem("permission");

  if (!token) {
    return <Navigate to="/" />;
  }

  if (userRole === "SuperAdmin") {
    return children;
  }

  let permissions = [];

  try {
    if (storedPermission) {
      const parsedPermission = JSON.parse(storedPermission);

      if (Array.isArray(parsedPermission)) {
        permissions = parsedPermission;
      } else if (typeof parsedPermission === "string") {
        permissions = [parsedPermission];
      }
    }
  } catch (error) {
    if (storedPermission) {
      permissions = storedPermission
        .split(",")
        .map((permission) => permission.trim())
        .filter(Boolean);
    }
  }

  if (!permissions.includes(pageCode)) {
    return <Navigate to="/Dashboard" />;
  }

  return children;
};

const MainLayout = ({
  children,
  sidebarOpen,
  setSidebarOpen,
  menuOpen,
  setMenuOpen,
}) => {
  return (
    <>
      <Navbar
        onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      <Sidebar isExpanded={sidebarOpen} setIsExpanded={setSidebarOpen} />

      <main
        className={`main-content-App ${sidebarOpen ? "sidebar-expanded" : ""}`}
      >
        {children}
      </main>
    </>
  );
};

export default App;
